import { XIcon } from '@phosphor-icons/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, Text } from '@components';
import { Translation, VariantType } from '@enums';

export const NoPermissions = () => {
  const navigate = useNavigate();

  const { t: tcError } = useTranslation(Translation.Common, { keyPrefix: 'errors' });
  const { t: tCommon } = useTranslation(Translation.Common, { keyPrefix: 'button' });

  const handleNavigateBack = useCallback(() => {
    navigate(-1);
  }, []);

  return (
    <div className="items-center max-w-80 justify-center flex flex-col gap-10 m-auto">
      <XIcon weight="bold" className="w-16 h-16 text-white bg-red-700 rounded-full p-2" />
      <div className="flex flex-col gap-5 text-center ">
        <Text color="dark:text-white">{tcError('accessDenied')}</Text>
        <Text $level={3}>{tcError('sorryAboutThatButYouDontHavePermissionToAccessThisPage')}</Text>
      </div>
      <Button className="enabled:shadow-none" variant={VariantType.Clean} onClick={handleNavigateBack}>
        {tCommon('goBack')}
      </Button>
    </div>
  );
};
